import { Label as ChordsLabel } from '~/chords/Label';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const Label = withClassNameHoc(ChordsLabel);
